import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getCustomerVisitsWithQueries = async (details) => {
  const response = await axios.put(
    endpoints.getSalesReportsWithQueriesURL,
    details
  );
  return response;
};
